import {Component, Input} from '@angular/core';
import {ZoneLightPrlObj} from '../../../../../../generated/generated.model';
import {PrlZonesListComponent} from "../prl-zones-list/prl-zones-list.component";
import {PrlZonesGalleryComponent} from "../prl-zones-gallery/prl-zones-gallery.component";

@Component({
    selector: 'prl-zones',
    imports: [
        PrlZonesGalleryComponent,
        PrlZonesListComponent,
    ],
    templateUrl: './prl-zones.component.html',
    styleUrl: './prl-zones.component.scss',
})
export class PrlZonesComponent {
    @Input() zones: ZoneLightPrlObj[];
    @Input() gridView: 'list' | 'gallery' = 'gallery';
}
